module.exports = __webpack_public_path__ + "media/images/ie-7448552f7bf7fcfcb6578d1ad40875b8.svg";